const globals = {
  state: {
    folderStatusArchived: { name: 'Arquivado' },
    dialogInstructionsPassword: false,
    dialogUpdatePassword: false,
    loading: { show: false, component: '' },
    modalAvatar: false,
    modalSignature: false,
    snackbar: { show: false, button: { show: true, text: 'Fechar' } },
    globalSearch: false,
    searchText: '',
    loadingSearchText: false,
    folderTypeSelected: '',
    hideFolderSidebar: false,
  },
  getters: {
    folderStatusArchived(state) {
      return state.folderStatusArchived;
    },
    globalSearch(state) {
      return state.globalSearch;
    },
    hideFolderSidebar(state) {
      return state.hideFolderSidebar;
    },
    searchText(state) {
      return state.searchText;
    },
    loadingSearchText(state) {
      return state.loadingSearchText;
    },
    folderTypeSelected(state) {
      return state.folderTypeSelected;
    },
    dialogInstructionsPassword(state) {
      return state.dialogInstructionsPassword;
    },
    dialogUpdatePassword(state) {
      return state.dialogUpdatePassword;
    },
    loading(state) {
      return state.loading;
    },
    modalAvatar(state) {
      return state.modalAvatar;
    },
    modalSignature(state) {
      return state.modalSignature;
    },
    snackbar(state) {
      return state.snackbar;
    },
  },
  mutations: {
    toggleLoader(state, payload) {
      state.loading = payload;
    },
    toggleModalAvatar(state, payload) {
      state.modalAvatar = payload;
    },
    toggleModalSignature(state, payload) {
      state.modalSignature = payload;
    },
    toggleSnackbar(state, payload) {
      state.snackbar = { ...state.snackbar, ...payload };
    },
    toggleInstructionsPassword(state, payload) {
      state.dialogInstructionsPassword = payload;
    },
    toggleUpdatePassword(state, payload) {
      state.dialogUpdatePassword = payload;
    },
    setGlobalSearch(state, payload) {
      state.globalSearch = payload;
    },
    setHideFolderSidebar(state, payload) {
      state.hideFolderSidebar = payload;
    },
    setSearchText(state, payload) {
      state.searchText = payload;
    },
    setLoadingSearchText(state, payload) {
      state.loadingSearchText = payload;
    },
    setFolderTypeSelected(state, payload) {
      state.folderTypeSelected = payload;
    },
  },
  actions: {
    toggleLoader({ commit }, payload) {
      commit('toggleLoader', payload);
    },
    toggleModalAvatar({ commit }, payload) {
      commit('toggleModalAvatar', payload);
    },
    toggleModalSignature({ commit }, payload) {
      commit('toggleModalSignature', payload);
    },
    toggleSnackbar({ commit }, payload) {
      commit('toggleSnackbar', payload);
    },
    toggleInstructionsPassword({ commit }, payload) {
      commit('toggleInstructionsPassword', payload);
    },
    toggleUpdatePassword({ commit }, payload) {
      commit('toggleUpdatePassword', payload);
    },
    setGlobalSearch({ commit }, value) {
      commit('setGlobalSearch', value);
    },
    setHideFolderSidebar({ commit }, value) {
      commit('setHideFolderSidebar', value);
    },
    setSearchText({ commit }, value) {
      commit('setSearchText', value);
    },
    setLoadingSearchText({ commit }, value) {
      commit('setLoadingSearchText', value);
    },
    setFolderTypeSelected({ commit }, value) {
      commit('setFolderTypeSelected', value);
    },
  },
};

export default globals;



// WEBPACK FOOTER //
// ./src/vuex/globals.js